
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/components/image-with-text",
      function () {
        return require("private-next-pages/design-system/components/image-with-text.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/components/image-with-text"])
      });
    }
  